const pt = {
  translation: {
    nav: {
      home: 'Início', about: 'Quem Somos', actions: 'Programas', stats: 'Impacto',
      partners: 'Parceiros', contact: 'Contacto', donate: 'Apoiar',
    },
    footer: {
      tagline: 'Promover o desenvolvimento humano e comunitário sustentável.',
      rights: 'Todos os direitos reservados.',
      privacy: 'Política de Privacidade',
      transparency: 'Relatório de Transparência',
      registered: 'Organização filantrópica angolana criada a 20 de Fevereiro de 2020.',
    },
  }
};
export default pt;
